var r;!function(r){r.PRIMARY="primary",r.SUCCESS="success",r.DANGER="danger",r.DARK="dark",r.WARNING="warning"}(r||(r={}));export{r as AttentionBoxType};
